module.exports = __webpack_public_path__ + "static/media/user-icon-1.23ec34c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-icon-1.png
// module id = 324
// module chunks = 0